import { useEffect } from 'react';
import { Form, Row, Col } from 'antd';
import CustomInput from '../CustomInput/Input';
import CustomSelect from '../CustomSelect/CustomSelect';
import { nameRules, phoneNumberRules } from '../../helpers/helpers';
import { useDispatch, useSelector } from 'react-redux';
import { getAllRelations } from '../../redux/slices/investorSlice';
import { BTN_TXT, ERROR_MSGS } from '../../constants/constants';
import CountryCode from '../CountryCodeSelect/CountryCode';
import dayjs from 'dayjs';
import CustomDatePicker from '../CustomDatePicker/CustomDatePicker';
import FormFooter from './FormFooter';
import { editinvestorDets, investorDetailedView } from '../../redux/slices/investorSlice';


const NomineeForm = ({
    data,
    onClose
}) => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { relationList, editInvErr, editInvSaveLoading } = useSelector((state) => state.investor);

    useEffect(() => {
        dispatch(getAllRelations());
    }, [dispatch]);

    const handleNomineeSubmit = async (Values) => {
        const payload = {
            nominee: {
                name: Values?.nomineeName,
                dob: Values?.nomineeDob,
                phoneNumber: Values?.phoneNumber,
                realtionshipId: Values?.relationship
            },
            orgId: data?.orgId
        }
        const res = await dispatch(editinvestorDets(payload))
        if (res.payload.statusCode === 201) {
            onClose()
            dispatch(investorDetailedView(data?.orgId))
        }
    }

    return (
        <Form
            layout="vertical"
            form={form}
            onFinish={handleNomineeSubmit}
            initialValues={{
                countryCode: "91",
                nomineeName: data?.name,
                nomineeDob: data?.dob,
                phoneNumber: data?.phoneNumber,
                relationship: data?.relationId,
            }}
            className="change-password-form"
        >
            <Row gutter={[16, 0]}>
                <Col xs={24} lg={12}>
                    <CustomInput
                        label="Nominee Legal Name"
                        name="nomineeName"
                        placeholder="Enter Name"
                        type="text"
                        rules={nameRules("")}
                    />
                </Col>
                <Col xs={24} lg={12}>
                    <CustomDatePicker
                        label="Nominee Date of Birth"
                        name="nomineeDob"
                        placeholder="Enter DOB"
                        rules={[{ required: true, message: ERROR_MSGS.ENTER_NOM_DOB }]}
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                </Col>
                <Col xs={24} lg={12}>
                    <CustomSelect
                        label="Relationship"
                        name="relationship"
                        placeholder="Select Relation"
                        options={relationList.map(rel => ({
                            value: rel.relationId,
                            label: rel.relationName.replace(/_/g, " ")
                        }))}
                        rules={[{ required: true, message: ERROR_MSGS.SEL_REL }]}
                    />
                </Col>
                <Col xs={24} lg={12}>
                    <CustomInput
                        label="Phone Number"
                        name="phoneNumber"
                        placeholder="Enter Phone Number"
                        addonBefore={<CountryCode />}
                        rules={phoneNumberRules("")}
                    />
                </Col>
            </Row>
            <FormFooter
                onCancelClick={() => {
                    onClose();
                    form.resetFields();
                }}
                submitLoading={editInvSaveLoading}
                btnName={BTN_TXT.SUBMIT}
                error={editInvErr}
            />
        </Form>
    );
};

export default NomineeForm;
